import { Routes } from '@angular/router';
import {
    layoutResolver,
    storyResolver
} from '@seven1/angular-storyblok-components/resolver';
import { routeChangeActivateGuard, routeChangeDeactivateGuard } from '@seven1/angular/gtm';
import { navigationDeactivateGuard } from '../../routing';

export const blog_routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./blog.page').then((page) => page.BlogPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard, navigationDeactivateGuard],
    },
    {
        path: 'kategorie/:categoryId',
        loadComponent: () => import('./category').then((page) => page.BlogCategoryPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard, navigationDeactivateGuard],
    },
    {
        path: ':articleId',
        loadComponent: () => import('./article').then((page) => page.BlogArticlePage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard, navigationDeactivateGuard],
    },
];
